import React from 'react'
import { useSelector } from 'react-redux'

import styles from '../../../Products.module.scss'

import { selectProxyCheckerLoading } from 'store/service/selectors'

import InputGroup from 'components/elements/forms/InputGroup'
import CustomInput from 'components/elements/inputs/CustomInput'
import CopyBlock from 'components/elements/blocks/CopyBlock'
import CustomButton from '../../../../../elements/buttons/CustomButton'

interface ICredentialsResultProps {
  login: string
  password: string
  server: string
  port: string
  activeSessionLengthType: any
  onGenerateIpClick: () => void
  onCheckProxyConnection: () => void
}

const CredentialsResult: React.FC<ICredentialsResultProps> = (props) => {
  const {
    login,
    password,
    server,
    port,
    activeSessionLengthType,
    onGenerateIpClick,
    onCheckProxyConnection,
  } = props

  const proxyCheckerLoading = useSelector(selectProxyCheckerLoading)

  const handleGenerateIp = () => {
    onGenerateIpClick()
  }

  const handleCheckProxy = () => {
    onCheckProxyConnection()
  }

  return (
    <div>
      <div className={styles.resultNotice}>
        <p>
          Use for a simple connection by entering credentials directly in your
          software.
        </p>
        <p>
          To connect, please enter the following credentials in your preferred
          software.
        </p>
      </div>

      <div className={styles.controls}>
        <CustomButton
          className={styles.rowBtn}
          color={'outline'}
          loading={proxyCheckerLoading}
          onClick={handleCheckProxy}
        >
          Check proxy connection
        </CustomButton>
      </div>

      <div className={styles.resultInputGroup}>
        <InputGroup
          labelTop={'Username'}
          labelClassName={styles.resultsLeftLabel}
        />

        <CopyBlock
          className={styles.copyUsernameBlock}
          text={login}
          disableBtn={activeSessionLengthType === 'new'}
          onSlotBtnClick={handleGenerateIp}
        />
      </div>

      <InputGroup
        labelTop={'Password'}
        className={styles.resultInputGroup}
        labelClassName={styles.resultsLeftLabel}
      >
        <CustomInput copyable value={password} />
      </InputGroup>

      <div className={styles.inputGroupRow}>
        <InputGroup
          labelTop={'Host'}
          className={styles.resultInputGroup}
          labelClassName={styles.resultsLeftLabel}
        >
          <CustomInput copyable value={server} />
        </InputGroup>

        <InputGroup
          labelTop={'Port'}
          className={styles.resultInputGroup}
          labelClassName={styles.resultsLeftLabel}
          childrenDirection={'vertical'}
        >
          <CustomInput copyable value={port} />
        </InputGroup>
      </div>

      <InputGroup
        labelTop={'Protocol'}
        className={styles.resultInputGroup}
        labelClassName={styles.resultsLeftLabel}
      >
        <CustomInput readOnly value={'HTTP / HTTPS / SOCKS5'} />
      </InputGroup>
    </div>
  )
}

export default CredentialsResult
